import React from "react";

const Footer = () => {
    return (
        <>
            <footer className="bg-black text-white">
                <div className="container py-5">
                    <div className="row mb-4">
                        <div className="col-md-6">
                            <div>
                                <p className="mb-0">GENERAL INQUIRY</p>
                                <a
                                    className="fs-3 text-decoration-underline text-white"
                                    href="mailto:glyphemail@gmail.com"
                                >
                                    glyphemail@gmail.com
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div>
                                <h6 className="fw-bold">Pakistan</h6>
                                <p className="mb-0">Main Gulberg </p>
                                <p className="mb-0">Lahore</p>
                                <p>54000</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div>
                                <h6 className="fw-bold">Pakistan</h6>
                                <p className="mb-0">Near Badshahi Masjid </p>
                                <p className="mb-0">Lahore</p>
                                <p>54000</p>
                            </div>
                        </div>
                    </div>
                    <div className="divider" />
                    <footer className="mt-4 footer-end-links">
                        <p className="mb-2 small">© CLYPH GROUP LLC. ALL RIGHTS RESERVED 2023.</p>
                        <div>
                            <a
                                href="https://www.instagram.com/codesinc_pakistan/"
                                className="text-white text-decoration-underline me-3 small"
                            >
                                INSTAGRAM
                            </a>
                            <a
                                href="https://x.com/codesinc_pak"
                                className="text-white text-decoration-underline me-3 small"
                            >
                                TWITTER
                            </a>
                            <a
                                href="https://www.facebook.com/codesincpak"
                                className="text-white text-decoration-underline me-3 small"
                            >
                                FACEBOOK
                            </a>
                            <a
                                href="https://www.linkedin.com/company/codesinc/?viewAsMember=true"
                                className="text-white text-decoration-underline small"
                            >
                                LINKEDIN
                            </a>
                        </div>
                    </footer>
                </div>
            </footer>

        </>
    );

};
export default Footer;